/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_FOLLOWUP_FEEDBACK_REPORT,
  LOAD_FOLLOWUP_FEEDBACK_REPORT_SUCCESS,
  LOAD_FOLLOWUP_FEEDBACK_REPORT_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(followupFeedbackData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    followupFeedbackData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Offer Report
export function loadFollowupFeedbackList(searchValue) {
  return {
    type: LOAD_FOLLOWUP_FEEDBACK_REPORT,
    searchValue,
  }
}
export function loadFollowupFeedbackListSuccess(followup_feedback_report) {
  return {
    type: LOAD_FOLLOWUP_FEEDBACK_REPORT_SUCCESS,
    followup_feedback_report,
  }
}
export function loadFollowupFeedbackListError(error) {
  return {
    type: LOAD_FOLLOWUP_FEEDBACK_REPORT_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadFollowupFeedbackList,
  loadFollowupFeedbackListSuccess,
  loadFollowupFeedbackListError,
}

export default actions
